import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { errorHandl } from 'src/app/utils/network-utils';
import { PlacementAuthService } from '../placement-auth-service/placement-auth.service';

@Injectable({
  providedIn: 'root'
})
export class PatientService {
  private http: HttpClient;

  constructor(private handler: HttpBackend, private placementAuthService: PlacementAuthService) {
    // Using HttpBackend to bypass interceptors that might overwrite the Authorization header
    this.http = new HttpClient(handler);
  }

  getPatients(){
    return this.placementAuthService.login().pipe(
      switchMap(token => {
        const headers = new HttpHeaders({
          'Authorization': `Bearer ${token}`
        });
         const params = new HttpParams().set('limit', '9999');
        return this.http.get<any>(`${this.placementAuthService.baseUrl}/responsible-parties/patients`, { headers, params });
      }),
      catchError(errorHandl)
    );
  }

  createPatient(payload: any) {
    return this.placementAuthService.login().pipe(
      switchMap(token => {
        const headers = new HttpHeaders({
          'Authorization': `Bearer ${token}`
        });
        return this.http.post<any>(`${this.placementAuthService.baseUrl}/responsible-parties/patients`, payload, { headers });
      }),
      catchError(errorHandl)
    );
  }

  getLevelOfCares() {
    return this.placementAuthService.login().pipe(
      switchMap(token => {
        const headers = new HttpHeaders({
          'Authorization': `Bearer ${token}`
        });
        return this.http.get<any>(`${this.placementAuthService.baseUrl}/level-of-care`, { headers });
      }),
      catchError(errorHandl)
    );
  }

  getPreIntakeData() {
    return this.placementAuthService.login().pipe(
      switchMap(token => {
        const headers = new HttpHeaders({
          'Authorization': `Bearer ${token}`
        });
        return this.http.get<any>(`${this.placementAuthService.baseUrl}/intake/pre`, { headers });
      }),
      catchError(errorHandl)
    );
  }

  getRelationships() {
    return this.placementAuthService.login().pipe(
      switchMap(token => {
        const headers = new HttpHeaders({
          'Authorization': `Bearer ${token}`
        });
        return this.http.get<any>(`${this.placementAuthService.baseUrl}/relationship-party`, { headers });
      }),
      catchError(errorHandl)
    );
  }

  getIntakeById(id: string){
    return this.placementAuthService.login().pipe(
      switchMap(token => {
        const headers = new HttpHeaders({
          'Authorization': `Bearer ${token}`
        });
        return this.http.get<any>(`${this.placementAuthService.baseUrl}/responsible-parties/intake/${id}`, { headers });
      }),
      catchError(errorHandl)
    );
  }

  updatePatientRecord(id: string, payload: any){
    return this.placementAuthService.login().pipe(
      switchMap(token => {
        const headers = new HttpHeaders({
          'Authorization': `Bearer ${token}`
        });
        return this.http.put<any>(`${this.placementAuthService.baseUrl}/responsible-parties/patient/${id}`, payload, { headers });
      }),
      catchError(errorHandl)
    );
  }

  getAccommodationTypes() {
    return this.placementAuthService.login().pipe(
      switchMap(token => {
        const headers = new HttpHeaders({
          'Authorization': `Bearer ${token}`
        });
        return this.http.get<any>(`${this.placementAuthService.baseUrl}/accommodations/types`, { headers });
      }),
      catchError(errorHandl)
    );
  }

  getPatientByRef(clientId: string | number) {
    return this.placementAuthService.login().pipe(
      switchMap(token => {
        const headers = new HttpHeaders({
          'Authorization': `Bearer ${token}`
        });
        return this.http.get<any>(`${this.placementAuthService.baseUrl}/responsible-parties/patient/${clientId}`, { headers });
      }),
      catchError(errorHandl)
    );
  }
}
